import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-brand-border flex flex-col h-full" data-id="element-53">
      <div className="flex gap-1 mb-4" data-id="element-54">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-55" />)}
      </div>

      <p className="text-brand-brown-light italic mb-6 flex-grow text-lg" data-id="element-56">
        "{content}"
      </p>

      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-brand-border" data-id="element-57">
        <div className="w-12 h-12 rounded-full bg-brand-peach flex items-center justify-center overflow-hidden" data-id="element-58">
          {image ? <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-59" /> : <span className="text-xl font-bold text-brand-coral" data-id="element-60">
              {name.charAt(0)}
            </span>}
        </div>
        <div data-id="element-61">
          <h4 className="font-bold text-brand-brown" data-id="element-62">{name}</h4>
          <p className="text-sm text-brand-brown-light" data-id="element-63">{role}</p>
        </div>
      </div>
    </div>;
}